import { render, staticRenderFns } from "./lista-de-correos.vue?vue&type=template&id=78353058&"
import script from "./lista-de-correos.vue?vue&type=script&lang=ts&"
export * from "./lista-de-correos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports